// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__3Fyuw","tab":"ProcedureTabs_tab__1kiQJ"};